import { render } from "./MonitoringVideos.vue?vue&type=template&id=671f67ac"
import script from "./MonitoringVideos.vue?vue&type=script&lang=js"
export * from "./MonitoringVideos.vue?vue&type=script&lang=js"

import "./MonitoringVideos.vue?vue&type=style&index=0&id=671f67ac&lang=scss"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__